import { combineReducers } from 'redux';
import facturation from './facturation.reducers';


const reducer = combineReducers({
    facturation
});

export default reducer;
